/**
 * @created on 2017/9/21
 * @author laixinyu <laixinyualex@gmail.com>
 **/

// 咨询-预约咨询
const ConsultList = resolve => require(['../../../views/ConsultList'], resolve)
const ConsultArrangeList = resolve =>
  require(['../../../views/consult/ConsultArrangeList'], resolve)
const UserOrderList = resolve =>
  require(['../../../views/consult/UserOrderList'], resolve)
const ResvOrderDetail = resolve =>
  require(['../../../views/ResvOrderDetail'], resolve)
const ResvComment = resolve => require(['../../../views/ResvComment'], resolve)
const ResvCancelReason = resolve =>
  require(['../../../views/ResvCancelReason'], resolve)
const ResvOrderHistory = resolve =>
  require(['../../../views/ResvOrderHistory'], resolve)
// const ConsultSearch          = resolve => require(['../../../views/ConsultSearch'], resolve);
const ConsultSearch = require('../../../views/ConsultSearch')
const ConsultOrderPage = resolve =>
  require(['../../../views/consult/ConsultOrderPage'], resolve)
// const ConsultDetail = resolve =>
//   require(['../../../views/ConsultDetail'], resolve)
const ResvRejectReason = resolve =>
  require(['../../../views/consult/ResvRejectReason'], resolve)
const ConsultOrderPagePerfect = resolve =>
  require(['src/views/consult/ConsultOrderPagePerfect.vue'], resolve)
// 私信v1.0 #1339
const consultMessageTips = resolve =>
  require(['src/views/consult/consultMessageTips.vue'], resolve)

export default [
  // 预约咨询
  {
    path: '/consult-list-teacher',
    component: ConsultList,
    name: 'consult-list-teacher',
    meta: {
      pageName: '订单列表页',
      business: '咨询'
    }
  },
  {
    path: '/consult-list-user',
    component: UserOrderList,
    name: 'consult-list-user',
    meta: {
      pageName: '订单列表页',
      business: '咨询'
    }
  },
  {
    path: '/consult-arrange-list',
    component: ConsultArrangeList,
    name: 'consult-arrange-list'
  },

  {
    path: '/consult-order-page',
    component: ConsultOrderPage,
    name: 'consult-order-page',
    meta: {
      pageName: '咨询购买服务页',
      business: '咨询'
    }
  },
  {
    path: '/consult-order-page-perfect',
    component: ConsultOrderPagePerfect,
    name: 'consult-order-page-perfect',
    meta: {
      pageName: '咨询补充信息页',
      business: '咨询'
    }
  },
  {
    path: '/resv-order-detail-teacher',
    component: ResvOrderDetail,
    name: 'resv-order-detail-teacher',
    meta: {
      pageName: '咨询订单详情',
      business: '咨询'
    }
  },
  {
    path: '/resv-order-detail-user',
    component: ResvOrderDetail,
    name: 'resv-order-detail-user',
    meta: {
      pageName: '咨询订单详情',
      business: '咨询'
    }
  },
  {
    path: '/resv-comment',
    component: ResvComment,
    name: 'resv-comment'
  },
  {
    path: '/resv-cancel-reason',
    component: ResvCancelReason,
    name: 'resv-cancel-reason'
  },
  {
    path: '/resv-order-history',
    component: ResvOrderHistory,
    name: 'resv-order-history'
  },
  {
    path: '/consult-search',
    component: ConsultSearch,
    name: 'consult-search'
  },
  // {
  //   path: '/consult-detail',
  //   component: ConsultDetail,
  //   name: 'consult-detail'
  // },
  {
    path: '/resv-reject-reason',
    component: ResvRejectReason,
    name: 'resv-reject-reason'
  },
  {
    path: '/consult-message-tips',
    component: consultMessageTips,
    name: 'consult-message-tips'
  }
]



// WEBPACK FOOTER //
// ./src/router/page/consult/appointment.js